import { PureComponent } from 'react';

import Link from 'Component/Link';
import media from 'Util/Media';

export class MenuqItem extends PureComponent {
    static defaultProps = {
        onItemClick: () => {}
    };

    renderPlusMinusIcon() {
        const { itemMods: { isExpanded } } = this.props;

        if (isExpanded) {
            return '-';
        }

        return '+';
    }

    renderExpandButton() {
        const { isExpandable, itemMods } = this.props;

        if (!isExpandable) {
            return null;
        }

        return (
            <figcaption
            block="Menuq"
            elem="ExpandedState"
            mods={ itemMods }
            >
                { this.renderPlusMinusIcon() }
            </figcaption>
        );
    }

    renderItemContentImage(icon) {
        if (!icon) {
            return null;
        }

        return (
            <img src={ media(icon) } />
        );
    }

    renderItemContent(item, itemMods) {
        const { title, icon } = item;

        return (
            <>
                { this.renderItemContentImage(icon, itemMods) }
                <span block="Menuq" elem="ItemText" mods={ itemMods }>
                    { title }
                </span>
            </>
        );
    }

    renderItemLinkContent() {
        const {
            activeMenuItemsStack,
            item,
            itemMods,
            handleCategoryHover,
            handleLinkLeave,
            onItemClick
        } = this.props;

        const {
            url,
            item_id
        } = item;

        const isHovered = activeMenuItemsStack.includes(item_id);

        return (
            <Link
              to={ url }
              block="Menuq"
              elem="ItemLink"
              id={ item_id }
              onMouseEnter={ handleCategoryHover }
              onMouseLeave={ handleLinkLeave }
              mods={ { isHovered } }
              onClick={ onItemClick }
            >
                { this.renderItemContent(item, itemMods) }
            </Link>
        );
    }

    render() {
        const { item, itemMods, isLink } = this.props;

        if (isLink) {
            return this.renderItemLinkContent();
        }

        return this.renderItemContent(item, itemMods);
    }
}

export default MenuqItem;
